export default __webpack_public_path__ + "static/media/login-user.601478b5.svg";